import React from 'react';

import { PAGE_TYPES } from '@dashboard/enums/page-types';

import usePage from '@dashboard/hooks/usePage';

import Link from '@dashboard/components/Link';

import PageEditView from '../components/PageEditView';

import Integrations from './PageSettings/Integrations';

const PageSettings = () => {
  const { page } = usePage();
  return (
    <PageEditView
      tabs={[
        {
          path: '/add-integrations',
          label: 'Integrations',
          component: (
            <div className="">
              {page.type === PAGE_TYPES.CHECKOUT && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when a customer completes a purchase.{' '}
                  <Link href="/help/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              {page.type === PAGE_TYPES.EVENT && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when someone makes a booking.{' '}
                  <Link href="/help/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              {page.type === PAGE_TYPES.FORM && (
                <div className="mb-4 text-gray-700">
                  Connect to your favorite apps and services. These integrations will be triggered
                  when a customer submits a form.{' '}
                  <Link href="/help/integrations" target="_blank">
                    Learn more
                  </Link>
                </div>
              )}

              <Integrations />
            </div>
          ),
        },
      ]}
    />
  );
};

export default PageSettings;
